import { useState } from 'react';
import { Wordmark } from '../brand/Brand';
import type { User } from '../api';
import * as api from '../api';

export function PlanPicker({ user }: { user: User }) {
  const [interval, setInterval] = useState<'yearly' | 'monthly'>('yearly');
  const [loading, setLoading] = useState(false);

  const handleProSubscribe = async () => {
    setLoading(true);
    try {
      const { url } = await api.checkout(interval);
      window.location.href = url;
    } catch {
      setLoading(false);
    }
  };

  const handleFreeContinue = () => {
    window.location.href = '/app';
  };

  return (
    <div className="plan-picker-page">
      <div className="plan-picker-container">
        {/* Header */}
        <div className="plan-picker-header">
          <Wordmark size={24} />
          <h1 className="plan-picker-title">Welcome to NeuralRepo</h1>
          <div className="plan-picker-user-card">
            {user.avatar_url && (
              <img src={user.avatar_url} alt="" className="plan-picker-avatar" />
            )}
            <div>
              {user.display_name && (
                <div className="plan-picker-user-name">{user.display_name}</div>
              )}
              <div className="plan-picker-user-email">{user.email}</div>
            </div>
          </div>
        </div>

        {/* Pro card */}
        <div className="plan-card plan-card-pro">
          <div className="plan-card-header">
            <span className="plan-badge plan-badge-pro">Pro</span>
            <div className="plan-interval-toggle">
              <button
                className={`plan-interval-btn${interval === 'yearly' ? ' plan-interval-active' : ''}`}
                onClick={() => setInterval('yearly')}
              >
                yearly
              </button>
              <button
                className={`plan-interval-btn${interval === 'monthly' ? ' plan-interval-active' : ''}`}
                onClick={() => setInterval('monthly')}
              >
                monthly
              </button>
            </div>
          </div>

          <div className="plan-price">
            {interval === 'yearly' ? (
              <>
                <span className="plan-price-amount">$70</span>
                <span className="plan-price-period">/year</span>
                <span className="plan-price-sub">$5.83/mo</span>
              </>
            ) : (
              <>
                <span className="plan-price-amount">$7</span>
                <span className="plan-price-period">/month</span>
              </>
            )}
          </div>

          <ul className="plan-features">
            <li><span className="plan-check">&#10003;</span> Unlimited ideas</li>
            <li><span className="plan-check">&#10003;</span> Unlimited semantic search &amp; duplicate detection</li>
            <li><span className="plan-check">&#10003;</span> Full mind maps, auto-tagging</li>
            <li><span className="plan-check">&#10003;</span> GitHub: commits, PRs, issues, Claude builds</li>
            <li><span className="plan-check">&#10003;</span> Siri Shortcuts, email capture</li>
            <li><span className="plan-check">&#10003;</span> BYOK, API access</li>
          </ul>

          <button
            className="btn btn-primary plan-cta"
            onClick={handleProSubscribe}
            disabled={loading}
          >
            {loading ? 'Redirecting...' : 'Start with Pro'}
          </button>
          <p className="plan-guarantee">7-day money-back guarantee</p>
        </div>

        {/* Free card */}
        <div className="plan-card plan-card-free">
          <div className="plan-card-header">
            <span className="plan-badge plan-badge-free">Free</span>
          </div>
          <div className="plan-price">
            <span className="plan-price-amount plan-price-free">$0</span>
            <span className="plan-price-period"> forever</span>
          </div>
          <ul className="plan-features plan-features-free">
            <li>50 ideas, web/Claude/CLI capture, keyword search, kanban, timeline, export</li>
          </ul>
          <button className="btn btn-ghost plan-cta" onClick={handleFreeContinue}>
            Continue with Free
          </button>
        </div>
      </div>
    </div>
  );
}
